import React from 'react';
import PropTypes from 'prop-types';
import { Layout, theme } from 'antd';
import CommonFooter from '../footer/CommonFooter.component';
import PublicHeader from './common/PublicHeader';

const { Content } = Layout;

const PortalLayout = ({ children }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout style={{ minHeight: '100vh', background: colorBgContainer }}>
      <PublicHeader />
      <Content style={{ background: colorBgContainer, overflowX: 'hidden' }}>
        <div style={{ maxWidth: 1180, margin: '0 auto', padding: '0 24px 48px' }}>
          {children}
        </div>
      </Content>
      <CommonFooter />
    </Layout>
  );
};

PortalLayout.propTypes = {
  children: PropTypes.node,
};

export default PortalLayout;
